import React, { useState } from "react";
import ConcertsYearGroup from "./ConcertsYearGroup.jsx";
import { concerts_show_more } from "./concerts.helper.jsx";
import json_navbar from "../UI/Navbar/Navbar.json";
import "./concerts.css";

const Concerts = ({ lang }) => {
  const thisYear = new Date().getFullYear();
  const [minYear, setMinYear] = useState(thisYear - 1);

  let years = [];
  for (let i = thisYear + 1; i >= minYear; i--) {
    years.push(i);
  }

  return (
    <div className="concerts">
      <h1>{json_navbar.concerts[lang]}</h1>
      {years.map((year, index) => (
        <ConcertsYearGroup key={index} lang={lang} year={year} />
      ))}
      <button className="concertButton" onClick={() => setMinYear(minYear - 1)}>
        {concerts_show_more[lang]}
      </button>
    </div>
  );
};

export default Concerts;



// WEBPACK FOOTER //
// ./src/components/Concerts/Concerts.jsx